import { render, staticRenderFns } from "./gameTag.vue?vue&type=template&id=417eb6e0&scoped=true"
import script from "./gameTag.vue?vue&type=script&lang=js"
export * from "./gameTag.vue?vue&type=script&lang=js"
import style0 from "./gameTag.vue?vue&type=style&index=0&id=417eb6e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417eb6e0",
  null
  
)

export default component.exports